import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'shadow',
      d: 'M0,-4h0.5v1.5h-0.5zM4,0h0.5v0.5h-0.5zM-4,0.5h1v0.5h-1zM-0.5,0.5h1.5v0.5h-1.5zM3.5,0.5h1v0.5h-1z',
    },
    {
      paint: 'trunk',
      d: 'M2,-5.5h0.5v0.5h-0.5zM-2.5,-5h1.5v0.5h-1.5zM1,-5h1v0.5h-1zM-2,-4.5h1v0.5h-1zM-0.5,-4.5h2.5v0.5h-2.5zM-1.5,-4h1v0.5h-1zM0.5,-4h1v1.5h-1zM-1,-3.5h0.5v0.5h-0.5zM-1.5,-3h1v2.5h-1zM0,-2.5h1.5v2h-1.5zM-2,-0.5h1v0.5h-1zM0.5,-0.5h2v0.5h-2zM-2.5,0h2v0.5h-2zM0.5,0h1v0.5h-1zM-3,0.5h2.5v0.5h-2.5zM1,0.5h1v0.5h-1z',
    },
    {
      paint: 'stump',
      d: 'M-1,-4.5h0.5v0.5h-0.5zM-0.5,-4h0.5v3.5h-0.5zM-1,-0.5h1.5v0.5h-1.5zM-0.5,0h1v0.5h-1z',
    },
    {
      paint: 'bushDark',
      d: 'M5,-12h1v0.5h-1zM4.5,-11.5h2.5v0.5h-2.5zM4,-11h3.5v0.5h-3.5zM2,-10.5h5.5v1h-5.5zM1.5,-9.5h6v1h-6zM-0.5,-8.5h3.5v0.5h-3.5zM3.5,-8.5h3.5v0.5h-3.5zM-1,-8h7.5v0.5h-7.5zM-1.5,-7.5h8v0.5h-8zM-2,-7h8.5v0.5h-8.5zM-5,-6.5h11v0.5h-11zM-5.5,-6h11.5v0.5h-11.5zM-5,-5.5h7v0.5h-7zM2.5,-5.5h2.5v0.5h-2.5zM-4,-5h1v0.5h-1zM-1,-5h2v0.5h-2z',
    },
    {
      paint: 'leaf',
      d: 'M-1.5,-15h2.5v0.5h-2.5zM-2.5,-14.5h1v0.5h-1zM0.5,-14.5h1v0.5h-1zM2,-14.5h2v0.5h-2zM-2.5,-14h0.5v0.5h-0.5zM1,-14h3.5v0.5h-3.5zM-3,-13.5h0.5v0.5h-0.5zM-1.5,-13.5h6.5v0.5h-6.5zM-5,-13h10.5v0.5h-10.5zM-5.5,-12.5h11v0.5h-11zM-6,-12h1v0.5h-1zM-3.5,-12h8.5v0.5h-8.5zM-6,-11.5h0.5v1.5h-0.5zM-2,-11.5h6.5v0.5h-6.5zM-2,-11h6v0.5h-6zM-5,-10.5h7v0.5h-7zM-6.5,-10h8.5v0.5h-8.5zM-7,-9.5h8.5v0.5h-8.5zM-7.5,-9h9v0.5h-9zM-7.5,-8.5h7v0.5h-7zM-7.5,-8h6.5v0.5h-6.5zM-7.5,-7.5h4.5v0.5h-4.5zM-2.5,-7.5h1v0.5h-1zM-7,-7h5v0.5h-5zM-6.5,-6.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'leafLight',
      d: 'M-1.5,-14.5h2v0.5h-2zM-2,-14h3v0.5h-3zM-2.5,-13.5h1v0.5h-1zM-5,-12h1.5v0.5h-1.5zM-5.5,-11.5h3.5v1h-3.5zM-5.5,-10.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'moss',
      d: 'M-4,-1.5h0.5v0.5h-0.5zM-4,-1h2v0.5h-2zM-4.5,-0.5h2.5v0.5h-2.5zM2.5,-0.5h0.5v0.5h-0.5zM-4,0h1.5v0.5h-1.5zM1.5,0h2.5v0.5h-2.5zM2,0.5h1.5v0.5h-1.5z',
    },
    { paint: 'acornBody', d: 'M3,-8.5h0.5v0.5h-0.5zM-3,-7.5h0.5v0.5h-0.5z' },
  ],
  pixels: 575,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'shadow',
      d: 'M-0.5,-3.5h0.5v0.5h-0.5zM-1,-3h1v0.5h-1zM-1,-2.5h1.5v1h-1.5zM-0.5,-1.5h1v0.5h-1zM-0.5,-1h0.5v0.5h-0.5zM2,-0.5h0.5v0.5h-0.5zM4,0h0.5v0.5h-0.5zM-4,0.5h2v0.5h-2zM0,0.5h1.5v0.5h-1.5zM3.5,0.5h1v0.5h-1z',
    },
    {
      paint: 'trunk',
      d: 'M0,-6.5h1v0.5h-1zM2.5,-6.5h1v0.5h-1zM-0.5,-6h1.5v1h-1.5zM2,-6h1.5v0.5h-1.5zM-2.5,-5.5h1.5v0.5h-1.5zM1.5,-5.5h1.5v0.5h-1.5zM-2.5,-5h0.5v0.5h-0.5zM-1.5,-5h4.5v0.5h-4.5zM-2,-4.5h0.5v1h-0.5zM-1,-4.5h3.5v0.5h-3.5zM-0.5,-4h2.5v0.5h-2.5zM-2,-3.5h1v1.5h-1zM0,-3.5h1.5v1h-1.5zM0.5,-2.5h1v1.5h-1zM-1.5,-2h0.5v1h-0.5zM-2,-1h0.5v0.5h-0.5zM0,-1h1.5v0.5h-1.5zM-2.5,-0.5h1v0.5h-1zM-0.5,-0.5h2.5v0.5h-2.5zM-2.5,0h4v0.5h-4zM-2,0.5h2v0.5h-2zM2,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'stump',
      d: 'M-2,-5h0.5v0.5h-0.5zM-1.5,-4.5h0.5v0.5h-0.5zM-1.5,-4h1v0.5h-1zM-1,-3.5h0.5v0.5h-0.5zM-1,-1.5h0.5v0.5h-0.5zM-1.5,-1h1v1h-1z',
    },
    {
      paint: 'bushDark',
      d: 'M2,-16.5h2v0.5h-2zM2.5,-16h2v0.5h-2zM2.5,-15.5h2.5v1.5h-2.5zM2,-14h3v1.5h-3zM2.5,-12.5h3v1.5h-3zM2,-11h3.5v1h-3.5zM1.5,-10h3.5v0.5h-3.5zM1.5,-9.5h3v0.5h-3zM1.5,-9h2.5v0.5h-2.5zM1,-8.5h2v0.5h-2zM3.5,-8.5h0.5v0.5h-0.5zM-0.5,-8h4.5v0.5h-4.5zM-1,-7.5h4.5v0.5h-4.5zM-1.5,-7h5v0.5h-5zM-3.5,-6.5h3.5v0.5h-3.5zM1,-6.5h1.5v0.5h-1.5zM-3.5,-6h3v0.5h-3z',
    },
    {
      paint: 'leaf',
      d: 'M-1,-17.5h2.5v0.5h-2.5zM-1.5,-17h0.5v0.5h-0.5zM1,-17h1v1h-1zM-2,-16.5h0.5v1h-0.5zM-1,-16h3.5v0.5h-3.5zM-2,-15.5h4.5v0.5h-4.5zM-3.5,-15h6v0.5h-6zM-4,-14.5h6.5v0.5h-6.5zM-4.5,-14h1.5v0.5h-1.5zM-2,-14h4v1h-4zM-4.5,-13.5h1v0.5h-1zM-4.5,-13h0.5v1.5h-0.5zM-2.5,-13h4.5v0.5h-4.5zM-3.5,-12.5h6v1h-6zM-4.5,-11.5h7v0.5h-7zM-4.5,-11h6.5v0.5h-6.5zM-5,-10.5h7v0.5h-7zM-5.5,-10h7v1.5h-7zM-5.5,-8.5h6.5v0.5h-6.5zM-5.5,-8h5v0.5h-5zM-5.5,-7.5h2.5v0.5h-2.5zM-2.5,-7.5h1.5v0.5h-1.5zM-5,-7h3.5v0.5h-3.5zM-4.5,-6.5h1v0.5h-1z',
    },
    {
      paint: 'leafLight',
      d: 'M-1,-17h2v0.5h-2zM-1.5,-16.5h2.5v0.5h-2.5zM-1.5,-16h0.5v0.5h-0.5zM-3,-14h1v0.5h-1zM-3.5,-13.5h1.5v0.5h-1.5zM-4,-13h1.5v0.5h-1.5zM-4,-12.5h0.5v1h-0.5z',
    },
    {
      paint: 'moss',
      d: 'M-4,-1.5h0.5v0.5h-0.5zM-4,-1h2v0.5h-2zM-4.5,-0.5h2v0.5h-2zM2.5,-0.5h0.5v0.5h-0.5zM-4,0h1.5v0.5h-1.5zM1.5,0h2.5v0.5h-2.5zM1.5,0.5h0.5v0.5h-0.5zM2.5,0.5h1v0.5h-1z',
    },
    { paint: 'acornBody', d: 'M3,-8.5h0.5v0.5h-0.5zM-3,-7.5h0.5v0.5h-0.5z' },
  ],
  pixels: 536,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'shadow',
      d: 'M0.5,-4.5h0.5v1h-0.5zM1,-0.5h0.5v0.5h-0.5zM2,-0.5h0.5v0.5h-0.5zM-1.5,0h0.5v0.5h-0.5zM4,0h0.5v0.5h-0.5zM-4,0.5h1v0.5h-1zM-2.5,0.5h2v0.5h-2zM3.5,0.5h1v0.5h-1z',
    },
    {
      paint: 'trunk',
      d: 'M-2.5,-7h1v0.5h-1zM1,-7h0.5v0.5h-0.5zM4.5,-7h0.5v0.5h-0.5zM-2.5,-6.5h2.5v0.5h-2.5zM0.5,-6.5h1.5v0.5h-1.5zM3.5,-6.5h1v0.5h-1zM-2,-6h1v0.5h-1zM-0.5,-6h2v0.5h-2zM2,-6h2v0.5h-2zM-1.5,-5.5h0.5v0.5h-0.5zM-0.5,-5.5h4v0.5h-4zM-1,-5h0.5v2.5h-0.5zM0,-5h3v0.5h-3zM1,-4.5h1.5v0.5h-1.5zM1,-4h1v0.5h-1zM0.5,-3.5h1v1.5h-1zM-1.5,-2.5h1v0.5h-1zM-1.5,-2h0.5v0.5h-0.5zM0.5,-2h0.5v0.5h-0.5zM-2,-1.5h1v0.5h-1zM0,-1.5h1v1h-1zM-2.5,-1h1v0.5h-1zM-2.5,-0.5h0.5v0.5h-0.5zM-0.5,-0.5h1.5v0.5h-1.5zM-3,0h1.5v0.5h-1.5zM-1,0h2.5v0.5h-2.5zM-3,0.5h0.5v0.5h-0.5zM-0.5,0.5h2.5v0.5h-2.5z',
    },
    {
      paint: 'stump',
      d: 'M-1,-6h0.5v1h-0.5zM-0.5,-5h0.5v0.5h-0.5zM-0.5,-4.5h1v2.5h-1zM-1,-2h1.5v0.5h-1.5zM-1,-1.5h1v0.5h-1zM-1.5,-1h1.5v0.5h-1.5zM-2,-0.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'bushDark',
      d: 'M4,-13.5h1.5v0.5h-1.5zM4.5,-13h1.5v0.5h-1.5zM5,-12.5h1.5v0.5h-1.5zM5,-12h2v0.5h-2zM4.5,-11.5h2.5v0.5h-2.5zM4,-11h3v0.5h-3zM2,-10.5h5v0.5h-5zM1.5,-10h6v0.5h-6zM-0.5,-9.5h0.5v0.5h-0.5zM0.5,-9.5h7v0.5h-7zM-1,-9h8.5v0.5h-8.5zM-5,-8.5h2v0.5h-2zM-1.5,-8.5h4.5v0.5h-4.5zM3.5,-8.5h3.5v0.5h-3.5zM-6.5,-8h13.5v0.5h-13.5zM-6,-7.5h3v0.5h-3zM-2.5,-7.5h8.5v0.5h-8.5zM-4.5,-7h1.5v0.5h-1.5zM-1.5,-7h2.5v0.5h-2.5zM1.5,-7h3v0.5h-3zM2,-6.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'leaf',
      d: 'M0,-14.5h2.5v0.5h-2.5zM-3,-14h2.5v0.5h-2.5zM2,-14h1v0.5h-1zM-4,-13.5h4.5v0.5h-4.5zM2.5,-13.5h1.5v0.5h-1.5zM-4,-13h0.5v0.5h-0.5zM-2.5,-13h7v0.5h-7zM-4.5,-12.5h0.5v1h-0.5zM-2,-12.5h7v0.5h-7zM-3.5,-12h8.5v0.5h-8.5zM-5.5,-11.5h10v0.5h-10zM-6.5,-11h10.5v0.5h-10.5zM-7,-10.5h9v0.5h-9zM-7,-10h8.5v0.5h-8.5zM-7,-9.5h6.5v0.5h-6.5zM0,-9.5h0.5v0.5h-0.5zM-7,-9h6v0.5h-6zM-7,-8.5h2v0.5h-2zM-3,-8.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'leafLight',
      d: 'M-0.5,-14h2.5v0.5h-2.5zM0.5,-13.5h2v0.5h-2zM-3.5,-13h1v0.5h-1zM-4,-12.5h2v0.5h-2zM-4,-12h0.5v0.5h-0.5z',
    },
    {
      paint: 'moss',
      d: 'M-4,-1.5h0.5v0.5h-0.5zM-4,-1h1.5v0.5h-1.5zM-4.5,-0.5h2v0.5h-2zM2.5,-0.5h0.5v0.5h-0.5zM-4,0h1v0.5h-1zM1.5,0h2.5v0.5h-2.5zM2,0.5h1.5v0.5h-1.5z',
    },
    { paint: 'acornBody', d: 'M3,-8.5h0.5v0.5h-0.5zM-3,-7.5h0.5v1h-0.5z' },
  ],
  pixels: 507,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
